import css from 'styled-jsx/css'

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .UserAccounts {
    .LoadingText {
      text-align: center;
      padding-bottom: 10px;
    }
  }

  .UserAccountsTable {
    padding: 10px 25px;
    display: flex;
    justify-content: flex-start;
    position: relative;

    &::after {
      content: '';
      width: 100%;
      height: 1px;
      background: #c5c5c5;
      position: absolute;
      left: 50%;
      top: 0;
      max-width: 310px;
      transform: translateX(-50%);

      @include respond-to(sm) {
        max-width: 100%;
      }
    }

    &__image {
      min-width: 30px;
      margin-right: 15px;
    }

    &__content {
      width: 70%;
    }

    &__line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    &__key {
      font-size: 1rem;
    }

    &__description {
      text-align: center;
      padding-bottom: 10px;
    }

    :global(.LoginCell__name) {
      display: none;
    }
  }
`

const getDynamicStyles = ({ colors }) => {
  return css`
    .UserAccountsTable {
      &__key {
        color: ${colors.gray.hex};
      }

      &__value {
        color: ${`rgba(${colors.black.rgb}, .8)`};

        :global(.MoneyCell__inner) {
          height: auto;

          :global(span) {
            font-size: 1rem !important;
            color: inherit !important;
          }
        }
      }
    }
  `
}

export { staticStyles, getDynamicStyles }
